import React from 'react';
import styled from 'styled-components';
import { colors, Text } from '../../globalStyles';
import { UpdateStaffRole } from '../../graphQL';
import { roleToAccountInfo } from '../../modelUtils/provider';
import {
  hasSai,
  hasSupportingClinicianRole,
  hasReferrerRole,
  OrgWithEntitlements,
} from './organizationUtils';

type Props = {
  organization: OrgWithEntitlements;
};

const AccountType = ({ role }: { role: UpdateStaffRole }) => {
  const { title, description } = roleToAccountInfo[role];
  return (
    <AccountTypeSection>
      <Text.bodyBold>{title}</Text.bodyBold>
      <Text.body>{description}</Text.body>
    </AccountTypeSection>
  );
};

export const OrganizationStaffRoles = ({ organization }: Props) => (
  <Container>
    <Text.h3>Account Types</Text.h3>
    <AccountType role={UpdateStaffRole.UniversityStaff} />
    {hasReferrerRole(organization) && <AccountType role={UpdateStaffRole.UniversityReferrer} />}
    {hasSupportingClinicianRole(organization) && (
      <AccountType role={UpdateStaffRole.UniversitySupportingClinician} />
    )}
    {hasSai(organization) && (
      <>
        <AccountType role={UpdateStaffRole.UniversityBeaconStaff} />
        <AccountType role={UpdateStaffRole.UniversityBeaconManager} />
      </>
    )}
    <AccountType role={UpdateStaffRole.UniversityAdmin} />
  </Container>
);

const Container = styled.div`
  padding: 2rem;
  border: 1px solid ${colors.grey.border};
  border-radius: 0.25rem;
  height: fit-content;
  max-width: 23.5rem;
`;

const AccountTypeSection = styled.div`
  padding: 1.25rem 0;
  :not(:last-child) {
    border-bottom: 1px solid ${colors.grey.border};
  }
`;
